module.exports = __webpack_public_path__ + "img/1557614082240094209.ef285a64.png";